<script setup>
defineProps({
  /** Primary button label (Save / Create / Submit). */
  confirmLabel: { type: String, required: true },
  cancelLabel: { type: String, default: '' },
  loading: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  /** When true, hide cancel. */
  hideCancel: { type: Boolean, default: false },
  /** primary | danger */
  confirmVariant: {
    type: String,
    default: 'primary',
    validator: (v) => ['primary', 'danger'].includes(v),
  },
  size: {
    type: String,
    default: 'small',
    validator: (v) => ['small', 'default'].includes(v),
  },
  loadingLabel: { type: String, default: '' },
})

defineEmits(['confirm', 'cancel'])
</script>

<template>
  <div class="form-actions">
    <button
      v-if="!hideCancel"
      type="button"
      class="btn ghost"
      :class="{ small: size === 'small' }"
      :disabled="loading"
      @click="$emit('cancel')"
    >
      {{ cancelLabel || $t('common.cancel') }}
    </button>
    <button
      type="submit"
      class="btn"
      :class="[confirmVariant, { small: size === 'small' }]"
      :disabled="disabled || loading"
      @click="$emit('confirm')"
    >
      {{ loading ? (loadingLabel || $t('common.saving')) : confirmLabel }}
    </button>
    <slot />
  </div>
</template>
